import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import PcNewApp from './PcNewApp';
import MiniApp from './pages/MiniApp';
import MiniAppShell from './pages/MiniAppShell';
import MobileApp from './pages/MobileApp';
import './styles/index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
const path = window.location.pathname;
const isMiniAppRoute = path.startsWith('/miniapp');
const isMiniAppAppRoute = path.startsWith('/miniapp/app');
const isMobileRoute = path.startsWith('/mobile');
const isPcNewRoute = path.startsWith('/pc-new');
root.render(
  isMiniAppAppRoute
    ? <MiniAppShell />
    : (isMiniAppRoute ? <MiniApp /> : (isMobileRoute ? <MobileApp /> : (isPcNewRoute ? <PcNewApp /> : <App />)))
);
